import { CountryLocation } from '../country-location.interface';
import { ProductHierarchy } from '../product-hierarchy.interface';

export const getSearchParamValueIfExists = (param: string): string => {
	const queryParams = new URLSearchParams(window.location.search);
	return queryParams.has(param) ? queryParams.get(param) : null;
};

export const isExpired = (timestamp: number): boolean => {
	// if timestamp is null (indicating indefinite expiration), return false (not expired)
	if (timestamp === null) {
		return false;
	}
	// if timestamp is valid, check if it has passed the current time
	const currentTime = Date.now();
	return currentTime > timestamp;
};

export const getFaasDataFromLocalStorage = (fieldName: string): string | null => {
	// get localStorage value
	const faasData = localStorage.getItem('faas-data');
	if (!faasData) return null;

	// check and remove expired data
	const faasDataParsed = JSON.parse(faasData);

	const fieldData = faasDataParsed[fieldName];

	// remove the expired field and return  null
	if (!fieldData || isExpired(fieldData.timestamp)) {
		if (fieldData) {
			delete faasDataParsed[fieldName];
			localStorage.setItem('faas-data', JSON.stringify(faasDataParsed));
		}
		return null;
	}

	return fieldData.value;
};

export const loadCountries = async (): Promise<{ label: string; value: string; }[]> => {
	const countries: { label: string; value: string; }[] = [];
	const response = await fetch('https://asset.mastercard.com/content/dam/dxp/dxp-faas/assets/country_locations.json');
	if (!response.ok) {
		throw new Error('failed to fetch countries');
	}
	const responseJson: CountryLocation = await response.json();
	countries.push(...Object.values(responseJson.countryLocation)
		.map((option) => ({ label: option, value: option })));
	return countries;
};

export const loadProductHierarchy = async (): Promise<ProductHierarchy> => {
	const response = await fetch('https://asset.mastercard.com/content/dam/dxp/dxp-faas/assets/product_hierarchy.json');
	if (!response.ok) {
		throw new Error('failed to fetch product hierarchy');
	}
	const responseJson: ProductHierarchy = await response.json();

	return responseJson;
};

export const trimTrailingSlash = (url: string) => (url.endsWith('/') ? url.slice(0, -1) : url);
